/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, ElementRef, Input, OnDestroy, Optional, SkipSelf} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {IfOpenService} from '../../utils/conditional/if-open.service';
import {POPOVER_HOST_ANCHOR} from '../common/popover-host-anchor.token';

import {ROOT_DROPDOWN_PROVIDER, RootDropdownService} from './providers/dropdown.service';
export class Dropdown implements OnDestroy {
private _subscription: Subscription;
/**
 * @param {?} parent
 * @param {?} ifOpenService
 * @param {?} dropdownService
 */
constructor(
public parent: Dropdown,
public ifOpenService: IfOpenService,
                dropdownService: RootDropdownService) {
        this._subscription = dropdownService.changes.subscribe(value => this.ifOpenService.open = value);
    }

     isMenuClosable: boolean = true;
/**
 * @return {?}
 */
ngOnDestroy() {
        this._subscription.unsubscribe();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dropdown",
    template: "<ng-content></ng-content>",
    host: {
        "[class.dropdown]": "true",
        // FIXME: remove this as soon as we stop supporting this old <div class="dropdown-menu"> syntax
        "[class.open]": "ifOpenService.open"
    },
    providers: [IfOpenService, ROOT_DROPDOWN_PROVIDER, {provide: POPOVER_HOST_ANCHOR, useExisting: ElementRef}]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Dropdown, decorators: [{ type: SkipSelf }, { type: Optional }, ]},
{type: IfOpenService, },
{type: RootDropdownService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isMenuClosable': [{ type: Input, args: ["clrCloseMenuOnItemClick", ] },],
};
}

function Dropdown_tsickle_Closure_declarations() {
/** @type {?} */
Dropdown.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Dropdown.ctorParameters;
/** @type {?} */
Dropdown.propDecorators;
/** @type {?} */
Dropdown.prototype._subscription;
/** @type {?} */
Dropdown.prototype.isMenuClosable;
/** @type {?} */
Dropdown.prototype.parent;
/** @type {?} */
Dropdown.prototype.ifOpenService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
